// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-actions .select-episode {
  color: var(--select-episode-button-color);
  background-color: var(--select-episode-button-bg-color);
}
.navbar-actions .select-episode:hover, .navbar-actions .select-episode:focus, .navbar-actions .select-episode:active {
  color: var(--select-episode-button-color_hover);
  background-color: var(--select-episode-button-bg-color_hover);
}
.navbar-actions__hamburger-icon-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 17px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/NavbarActions/NavbarActions.scss"],"names":[],"mappings":"AACI;EACI,yCAAA;EACA,uDAAA;AAAR;AAEQ;EAGI,+CAAA;EACA,6DAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AAJR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
